import { jsPDF } from "jspdf";

const WAIVER_WIDTH = 595.28;
const MARGIN = 15;

export const createWaiverPdf = async (input) => {
  if (!input) throw new Error("Waiver content is unavailable.");

  const clone = input.cloneNode(true);
  clone.id = "clone";
  clone.classList.remove("hidden", "d-none");
  clone.removeAttribute("hidden");
  clone.style.cssText = `display:block !important; height:auto !important; overflow:visible !important; width:${WAIVER_WIDTH}px; max-width:none; color:#000; background:#fff; font:12px Arial;`;
  document.body.append(clone);

  try {
    const width = clone.getBoundingClientRect().width;
    if (!Number.isFinite(width) || width <= 0) {
      throw new Error("Waiver content could not be laid out.");
    }

    const doc = new jsPDF("p", "px", "a4", true);
    await doc.html(clone, {
      x: 0,
      y: 0,
      margin: [MARGIN, MARGIN, MARGIN, MARGIN],
      autoPaging: "text",
      html2canvas: {
        useCORS: true,
        allowTaint: false,
        backgroundColor: "#ffffff",
        scale: (doc.internal.pageSize.width - MARGIN * 2) / width,
      },
    });
    return doc;
  } finally {
    clone.remove();
  }
};
